import React from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { List, Person, Gear, BoxArrowRight } from 'react-bootstrap-icons';

const MenuNavbar = ({ activeSection, setActiveSection }) => {
  const handleNavClick = (section) => {
    setActiveSection(section);
    // Force navbar collapse after selection
    const toggler = document.querySelector('.navbar-toggler');
    if (toggler && !toggler.classList.contains('collapsed')) {
      toggler.click();
    }
  };

  return (
    <Navbar bg="white" expand="lg" className="shadow-sm border-bottom sticky-top">
      <Container>
        <div className="d-flex gap-2">
          <Button
            variant={activeSection === 'header' ? 'primary' : 'light'}
            onClick={() => handleNavClick('header')}
          >
            Intestazione
          </Button>
          <Button
            variant={activeSection === 'menu' ? 'primary' : 'light'}
            onClick={() => handleNavClick('menu')}
          >
            Menu
          </Button>
        </div>

        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <List size={24} />
        </Navbar.Toggle>
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Item className="my-2">
              <Button variant="light" onClick={() => handleNavClick('profile')} className="w-100">
                <Person className="me-2" />
                Profilo
              </Button>
            </Nav.Item>
            <Nav.Item className="my-2">
              <Button variant="light" onClick={() => handleNavClick('settings')} className="w-100">
                <Gear className="me-2" />
                Impostazioni
              </Button>
            </Nav.Item>
            <Nav.Item className="my-2">
              <Button variant="danger" className="w-100">
                <BoxArrowRight className="me-2" />
                Esci
              </Button>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MenuNavbar;